export default "__VITE_ASSET__2Qi0EvDW__"